import React from 'react'
import Footer from '../../components/Footer';
import Videos from '../../components/Videos';
import texture from '../../images/TextureBlue060C1D.png'
//import Photos from '../Photos';

const Media = () => {
    return (
        <div className='flex flex-col min-h-screen'>
            <Videos />
            <div className='flex-1' style={{ backgroundImage: `url(${texture})`, backgroundRepeat: 'repeat' }} />
            <Footer />
        </div>
    )
}

export default Media
